import CellRender from "../../maze/render/CellRender.js";
import Spran from "../spran/Spran.js";

export default class TileAnimation {
	constructor(sp, cell, tile, level, animationsDefinitions) {
		this.sp = sp;
		this.cell = cell;
		this.tile = tile;
		this.level = level;
		this.animationsDefinitions = animationsDefinitions;
		this.spran = null;
		this.target = jQuery(level, this.tile);
		if (level === CellRender.LEVEL_STAND) {
			this.target.css("display", "block");
		}
		this.activated = true;

	}

	init(idAnimation) {
		this.spran = new Spran(this.sp, this.target, this.animationsDefinitions);
		this.spran.init();
		this.setAnimation(idAnimation);
	}

	setAnimation(idAnimation) {
		this.spran.setAnimation(idAnimation);
	}

	activateAnimation(lFlag) {
		if (lFlag) {
			this.spran.resume();
			this.activated = true;
		} else {
			this.spran.pause();
			this.activated = false;
		}
	}

	substAnimation(id, frame, props) {
		for (let x = 0; x < this.animationsDefinitions.length; x++) {
			if (this.animationsDefinitions[x].id == id) {
				let frames = this.animationsDefinitions[x].frames;
				for (var prop in props) {
					this.animationsDefinitions[x].frames[frame][prop] = props[prop];
				}
			}
		}
		//console.log(this.animationsDefinitions)
	}



}
